export default function getUserById(
  userId = null,
  users = {},
) {
  if (userId && Object.keys(users).length > 0) {
    return users[userId]
  } else return null
}
